import React from "react";
import { StatsCardCurrency, StatsCardDefault } from "./IndividualComponents";
import {
  Typography,
  Button,
  Input,
  Row,
  Col,
  Card,
  Space,
  Empty,
  Divider,
  Statistic,
  List
} from "antd";
import {
  SearchOutlined,
  UserOutlined,
  FileTextOutlined,
  DollarOutlined,
  ClusterOutlined,
  BarsOutlined,
  GlobalOutlined,
  StockOutlined,
} from "@ant-design/icons";
import * as _ from 'lodash';
const { Text } = Typography;


export const RecordDetailsList = (props) => {
  const { record } = props;
  const keyValPairs = _.toPairs(record);
  return (
    <div className="p-2">
      <List
      dataSource={keyValPairs}
      renderItem={item => (
        <List.Item>
          <Space><Typography.Text type="secondary"><small>{item[0]}</small></Typography.Text><Typography.Text strong>{item[1]}</Typography.Text></Space>
        </List.Item>
      )}
    />
    </div>
  );
};
